/**
 * Sobras PREVISTAS (D23): o plano de corte do Cut disse que sobraria; o
 * almoxarife confirma que existe (e em qual Box) ou que não existe.
 */
import React, { useCallback, useEffect, useState } from "react";

import AsyncButton from "../../../components/AsyncButton";
import { useAuth } from "../../../context/AuthContext";
import { confirmarSobraPrevista, linhasDe, listarSobrasPrevistas } from "../../../services/suprimentos";
import { nomeMaterialDaSobra } from "../../../utils/nomeMaterial";
import { Card, InlineHint, Select, Table, TableWrapper, TruncCell } from "../styles";
import { Medida } from "./styles";
import { fmtMm } from "./TabelaSobras";
import { Vazio } from "../_shared/Estados";

export default function PrevistasTab({ boxes, onMudou }) {
  const { request, isMaster, hasAllPermissions } = useAuth();
  const podeConfirmar = isMaster || hasAllPermissions(["sobra:change_status"]);
  const [previstas, setPrevistas] = useState([]);
  const [boxEscolhido, setBoxEscolhido] = useState({});

  const carregar = useCallback(async () => {
    setPrevistas(linhasDe(await listarSobrasPrevistas(request)));
  }, [request]);

  useEffect(() => { carregar().catch(() => setPrevistas([])); }, [carregar]);

  const confirmar = (s, existe) => async () => {
    await confirmarSobraPrevista(request, s.id, { existe, box: boxEscolhido[s.id] || null });
    await carregar();
    await onMudou();
  };

  return (
    <Card>
      <InlineHint>
        O plano de corte previu estes retalhos. Confirme só o que está fisicamente
        no galpão — sobra confirmada vira disponível para o próximo lote.
      </InlineHint>
      {previstas.length === 0 ? (
        <Vazio tone="ok" titulo="Nada aguardando confirmação" descricao="Quando um plano de corte prever retalhos, eles aparecem aqui para o almoxarife confirmar." />
      ) : (
        <TableWrapper>
          <Table>
            <colgroup>
              <col style={{ width: "12%" }} /><col style={{ width: "30%" }} /><col style={{ width: "16%" }} />
              <col style={{ width: "14%" }} /><col style={{ width: "28%" }} />
            </colgroup>
            <thead>
              <tr><th>Código</th><th>Material</th><th>Medidas (mm)</th><th>Origem</th><th>Confirmação</th></tr>
            </thead>
            <tbody>
              {previstas.map((s) => (
                <tr key={s.id}>
                  <td><TruncCell>{s.codigo}</TruncCell></td>
                  <td title={`${nomeMaterialDaSobra(s)} (${s.produto_codigo})`}><TruncCell>{nomeMaterialDaSobra(s)}</TruncCell></td>
                  <td><Medida>{fmtMm(s.comprimento_mm)} × {fmtMm(s.largura_mm)}</Medida></td>
                  <td><TruncCell>{s.origem_ref || s.origem_display}</TruncCell></td>
                  <td>
                    {podeConfirmar ? (
                      <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                        <Select
                          value={boxEscolhido[s.id] || ""}
                          onChange={(e) => setBoxEscolhido((p) => ({ ...p, [s.id]: e.target.value }))}
                          style={{ minWidth: 90 }}
                        >
                          <option value="">Box…</option>
                          {boxes.filter((b) => b.ativo).map((b) => <option key={b.id} value={b.id}>{b.codigo}</option>)}
                        </Select>
                        <AsyncButton variant="primary" successMessage="Sobra confirmada." onClick={confirmar(s, true)}>Existe</AsyncButton>
                        <AsyncButton variant="secondary" successMessage="Sobra descartada." onClick={confirmar(s, false)}>Não existe</AsyncButton>
                      </div>
                    ) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      )}
    </Card>
  );
}
